<portal-page [showBackground]="true" design="box">
  <p class="translation-text">{{ 'start_page.text.intro' | translate }}</p>
  <hr />
  @if (content$ | async; as content) {
    @if (content.header) {
      <h2 [innerHtml]="content.header"></h2>
    }
    @if (content.body) {
      <div [innerHtml]="content.body"></div>
    }
    @if (content.footer) {
      <div [innerHtml]="content.footer"></div>
    }
    <hr />
  }
  <portal-tutorial />
</portal-page>
